import { all, call, put, takeLatest, select } from "redux-saga/effects";
import { format } from "date-fns";
import {
  SEARCH_APPLICATIONS_REQUEST,
  SEARCH_USER_APPLICATIONS_REQUEST,
  searchApplicationsSuccess,
  searchApplicationsFailure,
  getProspectOverviewSuccess,
  getProspectOverviewFail,
  GET_PROSPECT_OVERVIEW_REQUEST,
  LOAD_MORE_SEARCH_APPLICATIONS,
  loadMoreSearchApplicationsSuccess,
  loadMoreSearchApplicationsFailure,
  UPDATE_RO,
  updateROFailure,
  GET_RO_PROSPECT_REQUEST,
  getROSuccess,
  getROFailure,
  updateROSuccess,
  SEND_USER_DROPOFF_AUTHORIZE_REQ,
  sendDropOffAuthSuccess,
  sendDropOffAuthFail
} from "../actions/searchProspect";
import { updateRoProspect } from "../actions/appConfig";

import { search, sendAdhocEmail } from "../../api/apiClient";
import { log } from "../../utils/loggger";
import { getAuthorizationHeader, getRoProspect } from "../selectors/appConfig";
import { prospect as prospectApi, salesAssitRO } from "../../api/apiClient";
import { validateAndFormatDate, getTodayFormattedTime } from "../../utils/helper";
import { cloneDeep } from "../../utils/cloneDeep";
import { DATE_FORMAT } from "../../constants";
export function* searchProspectFormSaga({ payload }) {
  try {
    const state = yield select();
    const searchPayload = cloneDeep(payload);
    const { fromDate, toDate, lastActionDate } = searchPayload;
    const today = format(new Date(), DATE_FORMAT);

    if (lastActionDate !== "") {
      const dt = validateAndFormatDate(lastActionDate);

      if (today === dt) {
        const formattedTime = getTodayFormattedTime();
        searchPayload.lastActionDate = `${dt}${formattedTime}`;
      } else {
        searchPayload.lastActionDate = `${dt}T23:59:59.999Z`;
      }
    }

    if (fromDate !== "") {
      const dt = validateAndFormatDate(fromDate);
      searchPayload.fromDate = `${dt}T00:00:00.000Z`;
    }

    if (toDate !== "") {
      const dt = validateAndFormatDate(toDate);

      if (today === dt) {
        const formattedTime = getTodayFormattedTime();
        searchPayload.toDate = `${dt}${formattedTime}`;
      } else {
        searchPayload.toDate = `${dt}T23:59:59.999Z`;
      }
    }

    const headers = getAuthorizationHeader(state);
    const response = yield call(search.searchApplication, searchPayload, headers);
    if (response.data.searchResult) {
      yield put(searchApplicationsSuccess(response.data.searchResult));
    } else {
      yield put(searchApplicationsFailure(response.data));
    }
  } catch (error) {
    yield put(searchApplicationsFailure({}));
    log(error);
  }
}

export function* getProspectOverviewSaga({ payload: { prospectId } }) {
  try {
    const headers = yield select(getAuthorizationHeader);
    const response = yield call(prospectApi.get, prospectId, headers);
    const prospect = response.data;

    yield put(getProspectOverviewSuccess(prospect));
  } catch (error) {
    log(error);
    yield put(getProspectOverviewFail(error));
  }
}

export function* searchUserProspectSaga({ payload }) {
  try {
    // const state = yield select();
    const headers = yield select(getAuthorizationHeader);
    const inputParam = {
      applicantName: payload.fullName || "",
      countryCode: payload.mobileNo ? payload.countryCode : "",
      mobileNo: payload.mobileNo || "",
      mobileNoType: payload.mobileNoType || "",
      tradeLicenseNo: payload.tradeLicenseNo || "",
      tradeLicenseIssueDate: payload.tradeLicenseIssueDate || "",
      tradeLicenseExpiryDate: payload.tradeLicenseExpiryDate || "",
      email: payload.email || "",
      emailType: payload.emailType || "",
      countryOfIncorporation: payload.countryOfIncorporation || "",
      companyName: payload.companyName || ""
    };

    const response = yield call(search.searchUserApplications, inputParam, headers);

    if (response.data.searchResult) {
      yield put(searchApplicationsSuccess(response.data.searchResult));
    } else {
      yield put(searchApplicationsFailure(response.data));
    }
  } catch (error) {
    yield put(searchApplicationsFailure({ status: error }));
    log(error);
  }
}

export function* loadMoreSearchProspectFormSaga({ payload }) {
  try {
    const state = yield select();
    const headers = getAuthorizationHeader(state);
    let searchObj = state.appConfig !== undefined ? state.appConfig.searchInfo : {};
    const inputParam = {
      countryCode: searchObj.mobileNo ? searchObj.countryCode : "",
      mobileNo: searchObj.mobileNo || "",
      tradeLicenseNo: searchObj.tradeLicenseNo || "",
      email: searchObj.email || ""
    };
    const response = yield call(search.searchApplication, inputParam, headers);
    if (response.data.searchResult) {
      yield put(
        loadMoreSearchApplicationsSuccess([
          ...response.data.searchResult,
          ...state.searchProspect.searchResults
        ])
      );
    } else {
      yield put(loadMoreSearchApplicationsFailure(response.data));
    }
  } catch (error) {
    yield put(loadMoreSearchApplicationsFailure({}));
    log(error);
  }
}

export function* updateROSaga({
  payload: { actionType, prospectID, preliminaryCriteria, saveType = "" }
}) {
  try {
    const state = yield select();
    const headers = getAuthorizationHeader(state);
    // getting Ro prospect from appconfig instead of search prospect
    const prospectRO = getRoProspect(state);
    prospectRO.applicationInfo.actionType = actionType;
    if (saveType) {
      prospectRO.applicationInfo.saveType = saveType;
    }
    prospectRO.preliminaryCriteria = { ...prospectRO.preliminaryCriteria, ...preliminaryCriteria };
    const response = yield call(salesAssitRO.update, { ...prospectRO }, headers, prospectID);
    yield put(updateROSuccess(response.data));
  } catch (err) {
    yield put(updateROFailure({}));
    log(err);
  }
}

export function* getROSaga({ payload: { prospectId } }) {
  try {
    const headers = yield select(getAuthorizationHeader);
    const response = yield call(salesAssitRO.get, prospectId, headers);
    if (response.status === 200)
      yield put(
        updateRoProspect({
          roProspect: response.data
        })
      );
    yield put(getROSuccess(response.data));
  } catch (error) {
    log(error);
    yield put(getROFailure(error));
  }
}

export function* sendUserDropOffAuthSaga({ payload: { data, prospectId } }) {
  try {
    const headers = yield select(getAuthorizationHeader);
    yield call(sendAdhocEmail.sendMail, data, headers, prospectId);
    yield put(sendDropOffAuthSuccess());
  } catch (error) {
    yield put(sendDropOffAuthFail({}));
    log(error);
  }
}
export default function* searchProspectSaga() {
  yield all([
    takeLatest(SEARCH_APPLICATIONS_REQUEST, searchProspectFormSaga),
    takeLatest(LOAD_MORE_SEARCH_APPLICATIONS, loadMoreSearchProspectFormSaga),
    takeLatest(GET_PROSPECT_OVERVIEW_REQUEST, getProspectOverviewSaga),
    takeLatest(SEARCH_USER_APPLICATIONS_REQUEST, searchUserProspectSaga),
    takeLatest(SEND_USER_DROPOFF_AUTHORIZE_REQ, sendUserDropOffAuthSaga),

    takeLatest(UPDATE_RO, updateROSaga),
    takeLatest(GET_RO_PROSPECT_REQUEST, getROSaga)
  ]);
}
